var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.addNewNodeAllowed)?_c('div',{staticClass:"clickable",on:{"click":_vm.onNodeAdd}},[_c('i',{staticClass:"mdi mdi-plus-circle-outline"}),_vm._v("\n  Agregar condición\n")]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }